import { render, staticRenderFns } from "./ProjectVcv.vue?vue&type=template&id=53fd601d&scoped=true&"
import script from "./ProjectVcv.vue?vue&type=script&lang=ts&"
export * from "./ProjectVcv.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectVcv.vue?vue&type=style&index=0&id=53fd601d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd601d",
  null
  
)

export default component.exports